import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1200000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
    config.headers['Authorization'] = `${store.getters.token}`
    console.log('请求', config)
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // 登录失效，跳转到登录页
    if (res.code === 40001) {
      Message({
        message: res.msg || '登录已失效，请重新登录',
        type: 'error',
        duration: 5 * 1000
      })
      // 等待token清除完成后再跳转
      store.dispatch('user/resetToken').then(() => {
        // 使用 router 跳转到登录页
        router.replace({ name: 'login' })
      })
      return Promise.reject(new Error(res.msg || '登录已失效'))
    }

    if (res.code !== 0 && res.code !== 'FILE_TYPE_NOT_SUPPORT_FAIL' && res.code !== 'Y') {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      if (res.code === 'Y') {
        return res
      } else if (res.code === 0) {
        return res
      } else {
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
        return res
      }
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
